<template>
  <div class="container-fluid py-4">

    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-gear fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Configuration système</h2>
      </div>
      <button 
        v-if="!configuration && $store.getters.hasPermission('CREATE_CONFIGURATION_SYSTEME')" 
        class="btn btn-primary btn-lg shadow-sm btn-clinique mt-2 mt-md-0" 
        @click="creer" :disabled="isLoading">
        <i class="bi bi-plus-circle me-1"></i> Créer une configuration
      </button>
      <button 
        v-else 
        class="btn btn-lg shadow-sm btn-clinique mt-2 mt-md-0" 
        @click="modifier" v-if="$store.getters.hasPermission('EDIT_CONFIGURATION_SYSTEME')" > 
        <i class="bi bi-pencil-square me-1"></i> Modifier
      </button>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;"></div>
      <p class="mt-3">Chargement de la configuration...</p>
    </div>

    <!-- Carte configuration -->
    <div v-else class="card p-4 shadow-sm rounded card-clinique">
      <div v-if="configuration">
        <h5 class="fw-bold text-success mb-3">
          <i class="bi bi-check-circle me-2"></i> Configuration enregistrée
        </h5>
        <ul class="list-group list-group-flush modern-list">
          <li class="list-group-item"><strong>Nom clinique :</strong> {{ configuration.nom }}</li>
           <li class="list-group-item"><strong>Ville :</strong> {{ configuration.ville }}</li>
          <li class="list-group-item"><strong>Adresse :</strong> {{ configuration.adresse }}</li>
          <li class="list-group-item"><strong>Téléphone :</strong> {{ configuration.telephone }}</li>
          <li class="list-group-item"><strong>Description :</strong> {{ configuration.description }}</li>
        </ul>
      </div>
      <div v-else>
        <h5 class="text-muted">Aucune configuration trouvée</h5>
        <p class="text-secondary">Veuillez créer une configuration système pour commencer.</p>
      </div>
    </div>

  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      configuration: null,
      isLoading: true
    };
  },
  methods: {
    async getConfiguration() {
      try {
        const response = await api.getItems('configurations');
        const data = response.data.data;
        this.configuration = data.length > 0 ? data[0] : null;
      } catch (error) {
        console.error('Erreur lors de la récupération de la configuration', error);
      } finally {
        this.isLoading = false;
      }
    },
    creer() { this.$router.push({ name: 'create_configuration_systeme' }); },
    modifier() { this.$router.push({ name: 'edit_configuration_systeme', params: { id: this.configuration.id } }); }
  },
  created() { this.getConfiguration(); }
};
</script>

<style scoped>
.header-clinique {
  background: #f8fafd;
  padding: 15px;
  border-radius: 12px;
  border: 1px solid #e5e9f2;
}

.card-clinique {
  border: 1px solid #e5e9f2;
  border-radius: 12px;
  background: #fff;
}

.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

.modern-list .list-group-item {
  padding: 12px 15px;
  border: none;
  border-bottom: 1px solid #f0f0f0;
}
.modern-list .list-group-item:last-child {
  border-bottom: none;
}
</style>
